import {useMutation, gql} from '@apollo/client'

export const MUTATE_CREATE_USER = gql`
  mutation MUTATE_CREATE_USER($email: Email!, $groupId: Numeric!, $firstName: Customname!, $lastName: Customname!) {
    createUser(email: $email, groupId: $groupId, firstName: $firstName, lastName: $lastName) {
      createUser {
        group_id
        email
        first_name
        last_name
      }
    }
  }
`

export function useAddDeliveryAdmin() {
  return useMutation(MUTATE_CREATE_USER, {
    context: {clientName: 'adminPanel'},
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
